<template>
  <div>
    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour de Cadastros de Adicionais de Sala
      </button>
    </div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 4"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  room_details.id ? "Editar Adicional" : "Cadastrar Adicional"
                }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description" id="v-step-1">
                            <span class="required">*</span> Título:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            autocomplete="new-password"
                            v-model="room_details.title"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="description" id="v-step-2">
                            <span class="required">*</span> Pré selecionado?:
                          </label>
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              id="remember"
                              class="custom-control-input"
                              v-model="room_details.pre_selected"
                            />
                            <label
                              for="remember"
                              class="custom-control-label"
                            ></label>
                            <small id="emailHelp" class="form-text text-muted"
                              >Se esta opção estiver ativa, ela aparecerá como
                              selecionada nas buscas do aplicativo.</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="limit_reservation" id="v-step-3"
                            ><span class="required"></span> Empresa:
                          </label>
                          <v-select
                            :options="companies"
                            label="company_name"
                            :reduce="(companies) => companies.id"
                            class="style-chooser"
                            v-model="room_details.company_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                    </div>

                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save" id="v-step-4">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/room_details" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Cadastro de Adicional de Sala",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content: "Insira um Título para esse Adicional.",
        },
        {
          target: "#v-step-2",
          params: {
            enableScrolling: false,
          },
          content:
            "Se Adicional tiver como Pré-Selecionado, ele irá aparecer automaticamente nas Salas.",
        },
        {
          target: "#v-step-3",
          params: {
            enableScrolling: false,
          },
          content: "Selecione a Empresa que este Adicional pertence.",
        },
        {
          target: "#v-step-4",
          params: {
            enableScrolling: false,
          },
          content: "Preenchendo todos os campos, basta clicar em Salvar.",
        },
      ],
      room_details: {
        title: "",
        pre_selected: "",
        company_id: "",
      },
      companies: [],
    };
  },
  methods: {
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 31) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("title", self.room_details.title);
      fd.append("company_id", self.room_details.company_id);
      if (self.room_details.pre_selected) {
        fd.append("pre_selected", self.room_details.pre_selected);
      } else {
        fd.append("pre_selected", false);
      }

      if (self.room_details.id) {
        fd.append("id", self.room_details.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "room_details";

      let fd = self.makeFormData();

      if (self.room_details.id) {
        api += "/" + self.room_details.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/room_details");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getRoomDetails: function (id) {
      const self = this;
      const api = self.$store.state.api + "room_details/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.room_details = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    self.getCompanies();
    if (id) {
      self.getRoomDetails(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style scoped>
.select {
  height: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/RoomsDetails/Add.vue